VLW.Compenents.CarteVin = class extends VLW.classBase {
	constructor(elt) {
		super(elt);
		this.constructor.instance = this;
		this.container            = document.querySelector(".body-LesVinsCartes");
		this.txt                  = this.elt.querySelectorAll("._carteSVG #txt text");
		TweenMax.to(this.container || {}, .5, {opacity: 1, ease: Power2.easeIn, delay: .33, pointerEvents: "auto"});
		this.constructor.positionnementDefaut = (typeof this.constructor.positionnementDefaut === "undefined") ? {} : this.constructor.positionnementDefaut;
		this.id                               = this.elt.getAttribute("data-carte-id");
		this.dateWheel                        = Date.now();
		this.svg                              = this.elt.querySelector("._carteSVG");
		this.mar                              = [...this.elt.querySelectorAll(".ui-svg-marker")];
		this.scaleMin                         = (Modernizr.touch === true) ? 1 : .5;
		this.scaleMax                         = this.elt.dataset.scaleMax || 10;
		this.scaleMin                         = this.elt.dataset.scaleMin || this.scaleMin;
		this.viewPort                         = {w: windowSize.width, h: windowSize.height};
		this.getOffset();
		this.setMarker();
		this.elt.addEventListener(EVENTS.MOUSEWHEEL, this.onMouseWheel);
		window.addEventListener("resize", this.onResize);
		if (Modernizr.touchevents === true) {
			this.touchHandler = new VLW.Compenents.CarteVinTouch(this);
			this.dragI        = {x: 0, y: 0};
			this.dragI.update = this.onTouchDragiUpdate;
		} else {
			Draggable.create(this.svg, {force3D: true, throwProps: true, throwResistance: 10000, onThrowUpdate: this.onDrag, onDrag: this.onDrag, onDragStart: this.onDragStart,});
			this.dragI = Draggable.get(this.svg);
		}
		let _ratio                                     = this.elt.dataset.scaleDefault || .8;
		var _o_                                        = {w: this.svg.getAttribute("data-width"), h: this.svg.getAttribute("data-height")};
		this.scaleDefault                              = Math.min(getDocSize().width / this.svg.getAttribute("data-width") * _ratio, getDocSize().height / this.svg.getAttribute("data-height") * _ratio);
		this.constructor.positionnementDefaut[this.id] = {
			x    : (this.viewPort.w * .5) - (_o_.w * this.scaleDefault * .5),
			y    : (this.viewPort.h * .5) - (_o_.h * this.scaleDefault * .3),
			scale: this.scaleDefault
		};
		
		this.mouseCarte = {x: 0, y: 0};
		this.scale      = this.constructor.positionnementDefaut[this.id].scale;
		this.oMouse     = {x: this.constructor.positionnementDefaut[this.id].x, y: this.constructor.positionnementDefaut[this.id].y};
		this.oMouse     = {x: this.viewPort.w * .5, y: this.viewPort.h * .5};
		TweenMax.set(this.svg, {transformOrigin: "0 0 0", x: this.constructor.positionnementDefaut[this.id].x, y:  this.constructor.positionnementDefaut[this.id].y,scale:this.scale ,force3D: true});
		this.hideText();
		
		setTimeout(() => {
			this.dragI.update();
			this.onCarteUpdate();
			this.zoom(this.constructor.positionnementDefaut[this.id].scale, true, false);
		}, 1);
		
	}
	
	hideText() {
		[...this.txt].forEach((elt) => {
			elt.style.opacity = 0;
		});
	}
	
	showText() {
		[...this.txt].forEach((elt) => {
			elt.style.opacity = 1;
		});
	}
	
	outro() {
		TweenMax.to(this.elt, .5, {opacity: 0});
	}
	
	onDragStart() {
		(CONFIG.ISDESKTO === true && browser.safari !== true && TweenMax.set(this.svg, {force3D: true}));
	}
	
	onDrag() {
		this.onCarteUpdate();
	}
	
	onResize() {
		clearTimeout(this.idOut);
		this.idOut = setTimeout(() => {
			this.viewPort = {w: getDocSize().width, h: getDocSize().height};
			let _x        = this.viewPort.w * .5 - this.carteGlobal.x;
			let _y        = this.viewPort.h * .5 - this.carteGlobal.y;
			TweenMax.set(this.svg, {x: _x, y: _y});
			this.carteGlobal = {x: this.viewPort.w * .5 - _x, y: this.viewPort.h * .5 - _y};
			this.dragI.update();
			this.onCarteUpdate();
		}, 10);
	}
	
	logDragI() {
	}
	
	setMarker() {
		this.mar.map(function (marker) {
			marker.x_natural = marker.getAttribute('data-x');
			marker.y_natural = marker.getAttribute('data-y');
		});
	}
	
	updateMarker(marker) {
		marker.style.transform = 'translate3d(' + parseInt(marker.x_natural * this.scale + this.dragI.x) + 'px,' + parseInt(marker.y_natural * this.scale + this.dragI.y) + 'px,0)';
	}
	
	onCarteUpdate() {
		this.mar.map(this.updateMarker);
		this.carteGlobal                               = {x: this.viewPort.w * .5 - this.dragI.x, y: this.viewPort.h * .5 - this.dragI.y};
		this.constructor.positionnementDefaut[this.id] = {x: this.dragI.x, y: this.dragI.y, scale: this.scale};
	}
	
	getOffset() {
		this.offset = {top: 0, left: 0};
	}
	
	getCarteMatrixtransform() {
		let style = window.getComputedStyle(this.svg);
		return new WebKitCSSMatrix(style.webkitTransform);
	}
	
	onTouchDragiUpdate() {
		let matrix   = this.getCarteMatrixtransform();
		this.dragI.x = matrix.m41;
		this.dragI.y = matrix.m42;
	}
	
	zoomByScrollBar(percent) {
		this.onMouseMove({clientX: this.viewPort.w * .5, clientY: this.viewPort.h * .5});
		this.zoom(this.scaleMin + (this.scaleMax - this.scaleMin) * percent, false);
	}
	
	zoom(scale, setSlider, doRepaint = true) {
		this.mouseCarte.x = ((this.oMouse.x) * 1 - (this.dragI.x)) / this.scale;
		this.mouseCarte.y = ((this.oMouse.y) * 1 - (this.dragI.y)) / this.scale;
		this.scale = scale;
		this.scale = Math.max(this.scale, this.scaleMin);
		this.scale = Math.min(this.scale, this.scaleMax);
		this.scale > 1.5 ? this.showText() : this.hideText();
		let _x = Math.floor(this.oMouse.x - this.mouseCarte.x * this.scale);
		let _y = Math.floor(this.oMouse.y - this.mouseCarte.y * this.scale);
		TweenMax.set(this.svg, {x: _x, y: _y, scale: this.scale, force3D: false});
		//let transform=`translate3D(${_x}px,${_y}px,0px) scale(${this.scale})`;
		//this.svg.style.transform = transform;
		this.dragI.update();
		this.onCarteUpdate();
		TweenMax.killDelayedCallsTo(this.repaintMap);
		//(setSlider !== false && this.myBar && TweenMax.set(this.myBar.target, {force3D: false, x: this.myBar.maxX * ((this.scale - this.scaleMin) / (this.scaleMax - this.scaleMin))}));
		if (VLW.Compenents.CarteVinScrollBar.instance) {
			VLW.Compenents.CarteVinScrollBar.instance.percent = (this.scale - this.scaleMin) / (this.scaleMax - this.scaleMin);
		}
		(doRepaint !== false && TweenMax.delayedCall(0.15, this.repaintMap));
	}
	
	zoomDelta(_delta) {
		this.zoom(this.scale + this.scale * _delta * .15, true);
	}
	
	setXY(x, y) {
		this.dragI.x = x;
		this.dragI.y = y;
		TweenMax.set(this.svg, {x: this.dragI.x, y: this.dragI.y, force3D: true});
		this.onCarteUpdate();
	}
	
	repaintMap() {
		window.oTween = {x: this.dragI.x, y: this.dragI.y, scale: this.scale, force3D: false};
		this.svg.classList.remove("zooming");
		//TweenMax.set(this.svg, window.oTween);
	}
	
	onMouseMove(e) {
		this.oMouse.x = e.clientX - this.offset.left;
		this.oMouse.y = e.clientY - this.offset.top;
	}
	
	onMouseWheel(e) {
		e.stopPropagation();
		e.preventDefault();
		if ((Date.now() - this.dateWheel) < 15) {
			return;
		}
		this.dateWheel = Date.now();
		this.onMouseMove(e);
		let _delta = ((e.detail ? e.detail * (-120) : e.wheelDelta) > 0) ? 1 : -1;
		this.zoom(this.scale + this.scale * _delta * .15, true);
		return false;
	}
	
	intro() {
	}
	
	instanceClean() {
		this.constructor.instance = null;
		TweenMax.to(this.container || {}, .5, {opacity: 0, pointerEvents: "none"});
		window.site.events.onLoadStart.remove(this.outro);
		if (Modernizr.touchevents === true) {
			this.touchHandler.instanceClean();
			this.touchHandler = null;
		} else {
			this.dragI.removeEventListener("press", this.onDrag);
			this.dragI.removeEventListener("drag", this.onDrag);
			this.dragI.kill();
		}
		this.elt.removeEventListener(EVENTS.MOUSEWHEEL, this.onMouseWheel);
		window.removeEventListener("resize", this.onResize);
		super.instanceClean();
	}
};
